<mat-card>  
    <div *ngIf="showCloseButton" class="clickable close-button" (click)="closeCustomer()">
      <span class="close-link">Close</span>
      <i class="material-icons close-icon" matTooltip="Close">close</i>
    </div>
  <mat-card-content>
    <div class="msg-content">
      <div class="unauthorized-text"><h2>Unauthorized Access.</h2></div>
      <div>
        <h4>
          You are not authorized to enter this location. Please check with
          system administrator to gain access.
        </h4>
      </div>
    </div>
  </mat-card-content>
</mat-card>
